import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Box, Table, Thead, Tbody, Tr, Th, Td, Button, Image, useToast } from '@chakra-ui/react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AuctionService from '../../services/AuctionService';
import Pagination from './Pagination';
import CustomSpinner from './CustomSpinner';
import Api from '../../api/ApiUrl'

const EndedAuctions = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);

  useEffect(() => {
    setSearchParams({ page, limit });
  }, [page, limit, setSearchParams]);

  const { data, isLoading, error, refetch } = useQuery(['endedAuctions', { page, limit }], () =>
    AuctionService.fetchEndedAuctions({ page, limit })
  );

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading auctions.</Box>;
  }

  return (
    <Box>
      <Table>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Description</Th>
            {/* <Th>Image</Th> */}
            <Th>Start Date</Th>
            <Th>End Date</Th>
            <Th>Total Bids</Th>
            <Th>Total Bid Amount</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.data?.map(auction => (
            <Tr key={auction._id}>
              <Td>{auction.name}</Td>
              <Td>{auction.description}</Td>
              {/* <Td> */}
                {/* <Image src={`${Api}/${auction.imagecover.path}`} alt={auction.imagecover.name} boxSize="50px" /> */}
              {/* </Td> */}
              <Td>{new Date(auction.startDate).toLocaleDateString()}</Td>
              <Td>{new Date(auction.endDate).toLocaleDateString()}</Td>
              <Td>{auction.totalBids}</Td>
              <Td>{auction.totalBidAmount}</Td>
              <Td>
                <Button colorScheme="blue" onClick={() => navigate(`/dashboard/admin/subcategory/${auction._id}/users`)}>View Users</Button>
              </Td>
              <Td>
                <Button colorScheme="blue" onClick={() => navigate(`/dashboard/admin/auctions/${auction._id}`)}>View Details</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Pagination page={page} setPage={setPage} limit={limit} total={data?.total} />
    </Box>
  );
};

export default EndedAuctions;
